/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Ref_N1Inputs */

const en_formatter_ref_n1 = /** @type {(inputs: Formatter_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trailing zeros are dropped. The value is unchanged.`)
};

const ko_formatter_ref_n1 = /** @type {(inputs: Formatter_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`뒤의 0이 사라집니다. 값은 그대로입니다.`)
};

const ja_formatter_ref_n1 = /** @type {(inputs: Formatter_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`末尾のゼロが落ちます。値は変わりません。`)
};

/**
* | output |
* | --- |
* | "Trailing zeros are dropped. The value is unchanged." |
*
* @param {Formatter_Ref_N1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_ref_n1 = /** @type {((inputs?: Formatter_Ref_N1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Ref_N1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_ref_n1(inputs)
	if (locale === "ko") return ko_formatter_ref_n1(inputs)
	return ja_formatter_ref_n1(inputs)
});